import axios from "axios";
import useGlobalPromise from "./useGlobalPromise";
import { VehicleServiceType } from "./Domain";

export default () =>
	useGlobalPromise("ald_vehicle_service_types", async () => (
		await axios.get<VehicleServiceType[]>("/api/vehicles/services/types")).data
	);
